import React from 'react';
import {connect} from 'react-redux';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import PdfItems from '../../components/PdfItems';
import {fetchFromHub} from '../../actions/networkActions';
import {defaultImageSrc} from "../../utils/imageUtils";
import VideoComponent from "../../components/VideoComponent";
import AudioComponent from "../../components/AudioComponent";
import LocationAndTimes from "../../components/LocationAndTimes";
import Description from "../../components/Description";

class FullScreenContent extends React.Component {
    constructor() {
        super();

        this.state = {
            images:null,
            imagesLoaded: false,
        }
    }

    componentDidMount() {
        this.props.fetchFromHub(
            `blobs/images/${this.props.contentId}`,
            this.updateImages
        )
    }

    updateImages = (imagesResponse) => {
        const images = imagesResponse.map((image) => {
            return {
                thumbnail: `${this.props.hubBaseUrl}${image.url}&width=200`,
                original: `${this.props.hubBaseUrl}${image.url}`,
            };
        }).slice(1);

        this.setState({
            images,
            imagesLoaded: true,
        });
    };

    render () {
        const contentHasImage = this.state.imagesLoaded && this.state.images && this.state.images.length > 0;
        const contentHasMultipleImages = contentHasImage && this.state.images.length > 1;
        const shouldShowLocationAndTimes = Boolean(this.props.whereAndWhen?.locationInfo || this.props.whereAndWhen?.locationInformation || this.props.whereAndWhen?.timeInformation);

        return (
            <div>
                <div className="grid-x grid-padding-x">
                    <div className="cell medium-12">
                        <h1>
                            <div dangerouslySetInnerHTML={{__html: this.props.title}}/>
                        </h1>

                        {contentHasImage &&
                        <ImageGallery
                            additionalClass="excursion-image-gallery full-screen-content"
                            items={this.state.images}
                            lazyLoad={true}
                            defaultImage={defaultImageSrc()}
                            showPlayButton={false}
                            showThumbnails={false}
                            useBrowserFullscreen={true}
                            showIndex={contentHasMultipleImages}
                            showFullscreenButton={contentHasMultipleImages}
                        />
                        }

                        <Description textContent={this.props.description}/>

                        { shouldShowLocationAndTimes &&
                            <LocationAndTimes whereAndWhen={this.props.whereAndWhen} />
                        }

                        <PdfItems items={this.props.pdfItems}/>

                        <AudioComponent audioItems={this.props.audioItems}/>

                        <VideoComponent videoItems={this.props.videoItems}/>

                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        hubBaseUrl: state.configuration.hubUrl.replace(/\/$/, ""),
    }
}

export default connect(mapStateToProps, {fetchFromHub}) (FullScreenContent);